import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TPVServices } from "../services";
import { Globals } from '../../../globals';
import { TakeawayServices } from '../../takeaway/services';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TpvLoaderPage } from '../tpv-loader/tpv-loader';
import * as moment from 'moment';
import { ConfigurationUsersPage } from '../../configuration/configuration-users/configuration-users';
import { ConfigurationRoomsPage } from '../../configuration/configuration-rooms/configuration-rooms';
import { OdsViewPage } from '../../ods/ods-view/ods-view';
import { TutorialPedidosPage } from '../../help/tutorials/tutorial-pedidos/tutorial-pedidos';
import { SalesZonesPage } from '../../analytics/reports/sales-zones/sales-zones';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { DeliveryTakeawaySalesPage } from '../../analytics/reports/delivery-takeaway-sales/delivery-takeaway-sales';
import { ConfigurationCloseCashViewPage } from '../../configuration/configuration-close-cash/configuration-close-cash-view/configuration-close-cash-view';
import { ArticlesListPage } from '../../articles/articles-list/articles-list';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsPage } from '../../analytics/analytics';
import { AnalyticsServices } from '../../services/analyticsServices';
import { KitchenPage } from '../../kitchen/kitchen';
import { OrdersLoaderPage } from '../../orders/orders-loader/orders-loader';

/**
 * Generated class for the TpvPanelPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-panel',
  templateUrl: 'tpv-panel.html',
})
export class TpvPanelPage {

  origin: string;
  showVideoModal: boolean = false; // Variable para controlar la visibilidad del modal
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public globals: Globals,
    public takeawayServices: TakeawayServices,
    public http: HttpClient,
    public translate: TranslateService,
    public analyticsServices: AnalyticsServices) {
    this.origin = this.navParams.get('origin');
    this.getAnalytics();
  }

  myAnalyticsData: any;
  valueChanges: any;
  ionViewWillEnter() {
    // Mostrar el modal automáticamente solo si NO tiene ningún módulo iniciado (starter)
    // Si alguno de los starter está en true, ya no se abre automáticamente
    if (!this.globals.restaurant.plg_pos_starter && 
        !this.globals.restaurant.plg_orders_starter && 
        !this.globals.restaurant.plg_kds_starter) {
      this.showVideoModal = true;
    }
    
    if (!this.globals.restaurant.plg_pos_finisher || !this.globals.restaurant.plg_orders_finisher || !this.globals.restaurant.plg_kds_finisher) {
      this.valueChanges = this.tpvServices.afs.doc('restaurants/' + this.globals.restaurant_uid).valueChanges().subscribe((value: any) => {
        this.globals.restaurant.plg_pos_starter = value.plg_pos_starter;
        this.globals.restaurant.plg_pos_finisher = value.plg_pos_finisher;
        //
        this.globals.restaurant.plg_orders_starter = value.plg_orders_starter;
        this.globals.restaurant.plg_orders_finisher = value.plg_orders_finisher;
        //
        this.globals.restaurant.plg_kds_starter = value.plg_kds_starter;
        this.globals.restaurant.plg_kds_finisher = value.plg_kds_finisher;
      });
    }
  }

  ionViewDidLeave() {
    if (this.valueChanges) {
      this.valueChanges.unsubscribe();
    }
    //clearInterval(this.myAnalyticsData);
  }

  async getAnalytics() {
    this.getInfoBilling();
    this.getInfoTakeaway();
    this.getInfoUsers();
    this.getInfoRooms();
    this.getInfoOrders();
    /*this.myAnalyticsData = setInterval(() => {
      this.getInfoBilling();
      this.getInfoTakeaway();
      this.getInfoUsers();
      this.getInfoRooms();
      this.getInfoOrders();
    }, 30000);*/
  }

  users_array: any = [];
  users_active: any = 0;
  users_loader: boolean = true;
  user_more_sale: any = {};
  getInfoUsers() {
    //user active
    for (let user of this.globals.users_array) {
      if (!user.disable) {
        this.users_active++;
      }
    }
    //users movements
    const params2 = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'));
    //waiters_movements_per_waiter
    this.http.post(this.globals.analytics_path + 'analytics/waiters_movements_per_waiter', params2, {})
      .subscribe(async response => {
        this.users_array = [];
        response['movements_data'].labels.forEach((usuario, index) => {
          let totalUsuario = 0;

          response['movements_data'].data.forEach(entry => {
            if (entry.data.length > 0) {
              totalUsuario += entry.data[index];
            }
          });

          this.users_array.push({
            user: usuario,
            total: totalUsuario
          });
        });
      });
    //waiters sales
    const params3 = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'))
      .set('currency_lang', this.globals.currency_lang);

    this.http.post(this.globals.analytics_path + 'analytics/waiters_sales', params3, {})
      .subscribe(async response => {
        if (response['data_waiters_sales']['data'][0] != undefined && response['data_waiters_sales']['labels'][0] != undefined) {
          this.user_more_sale.name = response['data_waiters_sales']['labels'][0];
          this.user_more_sale.sale = response['data_waiters_sales']['data'][0];
        }
        this.users_loader = false;
      });
  }

  info_rooms: any;
  total_rooms: number;
  total_active_tables: number;
  getInfoRooms() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key);

    this.http.post(this.globals.analytics_path + 'analytics/realtime24h_rooms_occupation', params, {})
      .subscribe(async response => {
        this.info_rooms = response;
        this.total_rooms = this.info_rooms.reduce((total, room) => total + room.total_tables_in_room, 0);
        this.total_active_tables = this.info_rooms.reduce((total, room) => total + room.total_tables_room_active, 0);
      }, err => {
        this.info_rooms = [];
        this.total_rooms = 0;
        this.total_active_tables = 0;
      });
  }

  total_billing: number;
  total_tips: number;
  getInfoBilling() {
    this.http.post(this.globals.analytics_path + 'biclosecash/get_totals', {
      public_key: this.globals.public_key,
      uid_cash: 'all',
      datetime_init: new Date(moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss')),
      datetime_final: new Date(moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss')),
    }, {}).subscribe(async data => {
      this.total_billing = data['total'];
      this.total_tips = data['total_tips'];
    }, err => {
      this.total_billing = 0;
      this.total_tips = 0;
    });
  }

  info_takeaway: any;
  getInfoTakeaway() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss'))
      .set('last_date', moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/realtime24h_takeaways', params, {})
      .subscribe(async response => {
        this.info_takeaway = response;
      }, err => {
        this.info_takeaway = [];
      });
  }

  total_orders: number;
  total_orders_tk: number;
  total_orders_table: number;
  avg_orders: number = 0;
  getInfoOrders() {
    var date_time_init = new Date(moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss'));
    var date_time_finish = new Date(moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'));
    this.globals.firestore.collection('orders').where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
      .where('show_kitchen', '==', true)
      .where('created_at', '>=', date_time_init)
      .where('created_at', '<=', date_time_finish).get().then(snapShot => {
        this.total_orders = snapShot.size;
        var info = [];
        snapShot.forEach(doc => {
          const data = doc.data();
          info.push(data);
        });
        this.total_orders_tk = info.reduce((total, order) => order.type == 'takeaway' ? total + 1 : total + 0, 0);
        this.total_orders_table = info.reduce((total, order) => order.type == 'table' ? total + 1 : total + 0, 0);
      });
    //
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/kitchen_avg_time_complete_order', params, {})
      .subscribe(async response => {
        if (response['list'].length > 0) {
          this.avg_orders = response['list'].reduce((total, order) => total + order.TIME_TO_COOK, 0);
          this.avg_orders = parseFloat((this.avg_orders / this.total_orders).toFixed(2));
        }
      });
  }

  openPos() {
    if (this.origin === 'kds') {
      this.globals.side_menu_active = 'kitchen';
      this.navCtrl.setRoot(KitchenPage);
    } else if (this.origin === 'tpv') {
      this.globals.side_menu_active = 'tpv';
      this.navCtrl.setRoot(TpvLoaderPage);
    } else {
      this.globals.side_menu_active = 'order';
      this.navCtrl.setRoot(OrdersLoaderPage);
    }
  }

  openUsers() {
    this.globals.side_menu_active = '';
    this.tpvServices.menu_select_room = '';
    this.navCtrl.push(ConfigurationUsersPage, {
      from: 'tpv'
    });
  }

  openUsersAnalytics() {
    this.globals.side_menu_active_analytics = true;
    this.globals.side_menu_active = 'informes';
    this.navCtrl.push(AnalyticsPage, {
      scroll_id: 'analytics_waiters'
    });
  }

  openRooms() {
    this.navCtrl.push(ConfigurationRoomsPage);
  }

  openRoomsAnalytics() {
    this.globals.side_menu_active_analytics = true;
    this.globals.side_menu_active = 'informes';
    if (this.globals.checkLimitsByLicense('analytics', 'analytics')) {
      this.navCtrl.push(SalesZonesPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  openTk() {
    if (this.globals.checkLimitsByLicense('sites', 'sites')) {
      this.globals.side_menu_active = 'web';
      this.navCtrl.setRoot(OdsViewPage);
      this.globals.side_menu_active_analytics = false;
    } else {
      this.globals.side_menu_active = 'web';
      this.globals.side_menu_active_analytics = false;
      this.navCtrl.push(TutorialPedidosPage);
    }
  }

  openTkAnalytics() {
    this.globals.side_menu_active_analytics = true;
    this.globals.side_menu_active = 'informes';
    if (this.globals.checkLimitsByLicense('analytics', 'analytics')) {
      this.navCtrl.push(DeliveryTakeawaySalesPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  openAnalytics() {
    this.navCtrl.push(AnalyticsPage);
  }

  openKdsAnalytics() {
    this.globals.side_menu_active_analytics = true;
    this.globals.side_menu_active = 'informes';
    this.navCtrl.push(AnalyticsPage, {
      scroll_id: 'analytics_kitchen'
    });
  }

  startPlg(origin) {
    if (origin === 'tpv') {
      this.tpvServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
        plg_pos_starter: true
      });
      this.globals.restaurant.plg_pos_starter = true;
      //update hubspot contact
      this.globals.updateERPNextCustomer();
      this.analyticsServices.trackingExpPos('starter', this.globals.tracking_exp['starter'], 'pos');
    } else if (origin === 'orders') {
      this.tpvServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
        plg_orders_starter: true
      });
      this.globals.restaurant.plg_orders_starter = true;
      //update hubspot contact
      this.globals.updateERPNextCustomer();
      this.analyticsServices.trackingExpPos('starter', this.globals.tracking_exp['starter'], 'orders');
    } else {
      this.tpvServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
        plg_kds_starter: true
      });
      this.globals.restaurant.plg_kds_starter = true;
      //update hubspot contact
      this.globals.updateERPNextCustomer();
      this.analyticsServices.trackingExpPos('starter', this.globals.tracking_exp['starter'], 'kds');
    }
    this.origin = origin;
  }

  openPlayStore(app) {
    switch (app) {
      case 'all':
        this.openLink('https://play.google.com/store/apps/developer?id=MyChefTool');
        break;
      case 'print':
        this.openLink('https://play.google.com/store/apps/details?id=com.mycheftool.printer');
        break;
      case 'kds':
        this.openLink('https://play.google.com/store/apps/details?id=com.mycheftool.kds');
        break;
      case 'order':
        this.openLink('https://play.google.com/store/apps/details?id=com.mycheftool.orders');
        break;
      case 'pos':
        this.openLink('https://play.google.com/store/apps/details?id=com.mycheftool.tpv');
        break;
      default:
        this.openLink('https://play.google.com/store/apps/developer?id=MyChefTool');
        break;
    }
  }

  openAppStore(app) {
    switch (app) {
      case 'all':
        this.openLink('https://apps.apple.com/es/developer/software-girona-sociedad-limitada/id918489945');
        break;
      case 'print':
        this.openLink('https://apps.apple.com/es/app/mct-print/id1624692351');
        break;
      case 'kds':
        this.openLink('https://apps.apple.com/es/app/mct-kitchen-display-system/id1625644596');
        break;
      case 'order':
        this.openLink('https://apps.apple.com/es/app/mct-order/id1626244345');
        break;
      case 'pos':
        this.openLink('https://apps.apple.com/es/app/mct-pos/id1628506564');
        break;
      default:
        this.openLink('https://apps.apple.com/es/developer/software-girona-sociedad-limitada/id918489945');
        break;
    }
  }

  openApp(app) {
    switch (app) {
      case 'all':
        if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
          this.openLink('https://apps.apple.com/es/developer/software-girona-sociedad-limitada/id918489945');
        } else {
          this.openLink('https://play.google.com/store/apps/developer?id=MyChefTool');
        }
        break;
      case 'print':
        if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
          this.openLink('https://apps.apple.com/es/app/mct-print/id1624692351');
        } else {
          this.openLink('https://play.google.com/store/apps/details?id=com.mycheftool.printer');
        }
        break;
      case 'kds':
        if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
          this.openLink('https://apps.apple.com/es/app/mct-kitchen-display-system/id1625644596');
        } else {
          this.openLink('https://play.google.com/store/apps/details?id=com.mycheftool.kds');
        }
        break;
      case 'order':
        if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
          this.openLink('https://apps.apple.com/es/app/mct-order/id1626244345');
        } else {
          this.openLink('https://play.google.com/store/apps/details?id=com.mycheftool.orders');
        }
        break;
      case 'pos':
        if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
          this.openLink('https://apps.apple.com/es/app/mct-pos/id1628506564');
        } else {
          this.openLink('https://play.google.com/store/apps/details?id=com.mycheftool.tpv');
        }
        break;
      default:
        if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
          this.openLink('https://apps.apple.com/es/developer/software-girona-sociedad-limitada/id918489945');
        } else {
          this.openLink('https://play.google.com/store/apps/developer?id=MyChefTool');
        }
        break;
    }
  }

  openLink(url) {
    if (this.globals.so_mobile) {
      window.location.assign(url);
    } else {
      window.open(url, '_blank');
    }
  }

  openTutorials(app) {
    switch (app) {
      case 'kds':
        if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
          this.openLink('https://mycheftool.zendesk.com/hc/es/sections/21035311469969-MCT-KDS-PRINT');
        } else {
          this.openLink('https://mycheftool.zendesk.com/hc/es/sections/21035311469969-MCT-KDS-PRINT');
        }
        break;
      case 'order':
        if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
          this.openLink('https://mycheftool.zendesk.com/hc/es/sections/21035307266961-MCT-Order');
        } else {
          this.openLink('https://mycheftool.zendesk.com/hc/es/sections/21035307266961-MCT-Order');
        }
        break;
      case 'pos':
        if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
          this.openLink('https://mycheftool.zendesk.com/hc/es/sections/21035333617553-MCT-POS');
        } else {
          this.openLink('https://mycheftool.zendesk.com/hc/es/sections/21035333617553-MCT-POS');
        }
        break;
      default:
        if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
          this.openLink('https://mycheftool.zendesk.com');
        } else {
          this.openLink('https://mycheftool.zendesk.com');
        }
        break;
    }
  }

  closeCash() {
    this.globals.side_menu_active = 'sales';
    this.navCtrl.push(ConfigurationCloseCashViewPage);
  }

  async getDemo() {
    var blocks = [
      {
        "type": "section",
        "text": {
          "type": "mrkdwn",
          "text": "NUEVA DEMO POS :technologist:"
        }
      },
      {
        "type": "section",
        "text": {
          "type": "mrkdwn",
          "text": ":knife_fork_plate: " + this.globals.restaurant.company +
            "\n :email: " + this.globals.restaurant.email +
            '\n :phone: ' + this.globals.restaurant.phone.toString() +
            '\n :round_pushpin: ' + this.globals.restaurant.address_country || ''
        }
      },
    ];
    const slack_params = new HttpParams()
      .set('msg', 'Nueva demo')
      .set('blocks', JSON.stringify(blocks))
      .set('channel', '#integracions-mct');
    await this.http.post(this.globals.analytics_path + 'send_slack', slack_params, {})
      .subscribe(async res => { });
    this.globals.launchToast(this.translate.instant('general-enviado-correctamente'), 3000, 'bottom');
  }

  async getInfoHardWare() {
    var blocks = [
      {
        "type": "section",
        "text": {
          "type": "mrkdwn",
          "text": "INFORMACIÓN PLAN RENOVE :desktop_computer: "
        }
      },
      {
        "type": "section",
        "text": {
          "type": "mrkdwn",
          "text": ":knife_fork_plate: " + this.globals.restaurant.company +
            "\n :email: " + this.globals.restaurant.email +
            '\n :phone: ' + this.globals.restaurant.phone.toString() +
            '\n :round_pushpin: ' + this.globals.restaurant.address_country || ''
        }
      },
    ];
    const slack_params = new HttpParams()
      .set('msg', 'Informacion plan renove')
      .set('blocks', JSON.stringify(blocks))
      .set('channel', '#integracions-mct');
    await this.http.post(this.globals.analytics_path + 'send_slack', slack_params, {})
      .subscribe(async res => { });
    this.globals.launchToast(this.translate.instant('general-enviado-correctamente'), 3000, 'bottom');
  }

  goToArticles() {
    this.globals.side_menu_active = 'dish';
    this.navCtrl.setRoot(ArticlesListPage);
  }

  openPlg(type) {
    this.startPlg(type);
    this.navCtrl.setRoot(TpvPanelPage, {
      origin: type
    });
  }

  openLandingPos() {
    if (this.globals.so_mobile) {
      window.location.assign('https://landing.mycheftool.com/es/punto-de-venta');
    } else {
      window.open('https://landing.mycheftool.com/es/punto-de-venta', '_blank');
    }
  }

  openLandingOrders() {
    if (this.globals.so_mobile) {
      window.location.assign('https://landing.mycheftool.com/es/punto-de-venta');
    } else {
      window.open('https://landing.mycheftool.com/es/punto-de-venta', '_blank');
    }
  }

  openLandingKds() {
    if (this.globals.so_mobile) {
      window.location.assign('https://landing.mycheftool.com/es/punto-de-venta');
    } else {
      window.open('https://landing.mycheftool.com/es/punto-de-venta', '_blank');
    }
  }

  closeVideoModal() {
    this.showVideoModal = false;
  }

  openVideoModal() {
    this.showVideoModal = true;
  }

  // Función helper para saber si mostrar el botón del video
  // Se muestra mientras no tenga todos los módulos finalizados
  shouldShowVideoButton(): boolean {
    return !this.globals.restaurant.plg_pos_finisher ||
            !this.globals.restaurant.plg_orders_finisher ||
            !this.globals.restaurant.plg_kds_finisher;
  }
}


// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-panel/tpv-panel.ts